<template>
  <div class="result-wrap">
    <back-button />
    <div class="draw-title">
      <img src="@/assets/img/draw-title.png" />
    </div>
    <!-- <div class="draw-record">
          <img src ="@/assets/img/draw-record.png" @click="$router.push()"/>
      </div> -->
    <div class="draw-chance">当前剩余抽奖次数：{{ drawChance }}</div>
    <div class="draw-content">
      <img
        class="pointer"
        src="@/assets/img/draw-pointer.png"
        :style="animateStyle"
        @click="doDraw"
      />
      <div
        class="award-item"
        v-for="(item, index) in prizeList"
        :key="index"
        :style="{
          transform: `rotate(${index * 45}deg)`,
        }"
      >
        <span v-if="item != 0">{{ item }}元</span>
      </div>
    </div>
    <div class="draw-bottom">
      <img src="@/assets/img/draw-bottom.png" />
    </div>

    <van-dialog
      v-model="redPackDialog"
      class="custom-dialog"
      :title="`恭喜抽中${prizeMoney}元`"
      @confirm="goResult"
    >
      <div class="custom-dialog_content">
        <div class="red-pack">
          <img
            class="red-pack-img"
            src="@/assets/img/red-pack.png"
            alt="红包"
          />
        </div>
        <div>
          说明：中奖红包已通过消息通知发送给您，请及时前往微信聊天中领取
        </div>
      </div>
    </van-dialog>
    <van-dialog
      v-model="missDialog"
      class="custom-dialog"
      title="很遗憾，未中奖"
      @confirm="goResult"
    >
      <div class="custom-dialog_content">
        <div class="miss-draw">
          <img src="@/assets/img/no-reward.png" alt="未中奖" />
        </div>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import BackButton from "@/components/BackButton.vue";
export default {
  components: {
    BackButton,
  },
  data() {
    return {
      // 抽中红包弹窗
      redPackDialog: false,
      // 未抽中弹窗
      missDialog: false,
      imgSrc: "",
      prizeList: [0, 0.3, 0.4, 0.5, 0, 0.6, 0.8, 1],
      isStart: false,
      config: {
        duration: 3000,
        circle: 7,
        easing: "ease-in-out",
      },
      prizeIndex: 0,
      prizeMoney: 0,
      drawChance: 1,
    };
  },
  computed: {
    allAngle() {
      const degs = 360 * this.config.circle + this.prizeIndex * 45;
      return degs;
    },
    animateStyle() {
      return this.isStart
        ? {
            transform: `rotate(${this.allAngle}deg)`,
            transition: `all ${this.config.duration}ms ${this.config.easing}`,
          }
        : {
            transform: `rotate(${0}deg)`,
          };
    },
  },
  methods: {
    // createRandom(min, max) {
    //   return Math.floor(Math.random() * (max - min + 1) + min);
    // },
    async doDraw() {
      if (this.isStart) {
        return false;
      }
      try {
        const res = await this.$axios.post(`/Redpackets/lotteryDraw`);
        this.prizeIndex = this.prizeList.indexOf(Number(res.data.money));
        this.prizeMoney = Number(res.data.money);
        if (Number(res.data.money) == 0) {
          if (Math.floor(Math.random() * 10) % 2 == 1) {
            this.prizeIndex = 4;
          }
          this.config.circle = 6;
        }
        this.drawChance--;
        this.isStart = true;
        setTimeout(() => {
          if (res.data.money) {
            this.redPackDialog = true;
          } else {
            this.missDialog = true;
          }
        }, 4000);

        console.log(res);
      } catch (error) {
        this.prizeIndex = 0;
        this.drawChance--;
        this.config.circle = 6;
        this.isStart = true;
        setTimeout(() => {
          this.missDialog = true;
        }, 4000);

        console.log(error);
      }
    },
    goResult() {
      this.missDialog = false;
      this.redPackDialog = false;
      this.isStart = false;
      if (this.drawChance == 0) {
        this.$router.replace(
          `/question/result?type=2&score=${this.$route.query.score}&duration=${this.$route.query.duration}`
        );
      }
    },
    async doRegister() {
      try {
        await this.$axios.post(`/user/registerScience`);
        if (this.drawChance < 2) {
          this.drawChance++;
          this.$notify({
            type: "success",
            message: "注册成功，额外获得1次抽奖机会",
            duration: 2000,
          });
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          message: error.errorMsg || "注册失败！",
          duration: 2000,
        });
        console.log(error);
      }
    },
    /**
     * 获取答题结果
     */
    // async hasDrawChance() {
    //   try {
    //     if (Number(this.score) > 2) {
    //       const res = await this.$axios.post(`/Redpackets/getLotteryNum`);
    //       if (res.data.success) {
    //         this.showPrizePopup = true;
    //       }
    //     }
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },
  },
};
</script>
<style lang="scss" scoped>
.result-wrap {
  position: relative;
  box-sizing: border-box;
  min-height: 100vh;
  padding: 40px 20px 20px;
  overflow: hidden;
  background: #a2d765 url("~@/assets/img/plain-bg.png") no-repeat top center;
  background-size: 100% 100%;

  .draw-title {
    // margin-top: 88px;
    text-align: center;
    img {
      width: 267px;
    }
  }
  .draw-chance {
    margin-top: 10px;
    font-size: 15px;
    font-weight: 600;
    color: #fff;
    text-align: center;
  }
  .draw-content {
    position: relative;
    z-index: 100;
    width: 340px;
    height: 340px;
    margin: 30px auto 0;
    background: url("~@/assets/img/draw-table.png") no-repeat top center/100%;
    // scale: 1.3;
    .pointer {
      position: absolute;
      top: 110px;
      right: 125px;
      z-index: 999;
      width: 90px;
      transform-origin: 50% 61px;
    }
    .award-item {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      width: 135px;
      height: 135px;
      margin: auto;
      font-size: 15px;
      line-height: 21px;
      color: #9c47fa;
      text-align: center;
    }
  }
  .draw-bottom {
    z-index: -1;
    margin-top: -30px;
    text-align: center;
    img {
      width: 300px;
    }
  }
  .register {
    text-align: center;
    .register-tip {
      padding: 9px 14px;
      font-size: 14px;
      line-height: 20px;
      color: #fff;
      background: rgba(254, 254, 254, 0.2);
      border-radius: 4px;
    }
    .register-btn {
      width: 165px;
      height: 37px;
      font-size: 16px;
      color: #9d000c !important;
    }
  }
  .draw-dialog {
    width: 228px;
    background-color: transparent;
    .draw-dialog_content {
      position: relative;
      width: 100%;
      height: 323px;
      text-align: center;
      background: url("~@/assets/img/draw-icon.png") no-repeat top center/100%;
      .draw-label {
        padding-top: 103px;
        font-size: 20px;
        font-weight: 600;
        line-height: 25px;
        color: #ef1c00;
      }
      .draw-info {
        margin-top: 3px;
        font-size: 14px;
        line-height: 25px;
        color: #ef1c00;
      }
      .draw-btn {
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 40px;
      }
    }
  }
  .custom-dialog_content {
    .red-pack {
      margin-bottom: 19px;
      text-align: center;
      .red-pack-img {
        width: 48px;
        height: 59px;
        transform: rotate(15deg);
        animation: shake 1s linear infinite;
      }
      @keyframes shake {
        0% {
          transform: rotate(0deg);
        }
        10% {
          transform: rotate(-15deg);
        }
        20% {
          transform: rotate(0deg);
        }
        30% {
          transform: rotate(15deg);
        }
        40% {
          transform: rotate(0deg);
        }
        50% {
          transform: rotate(-15deg);
        }
        60% {
          transform: rotate(0deg);
        }
        70% {
          transform: rotate(15deg);
        }
        80% {
          transform: rotate(0deg);
        }
        90% {
          transform: rotate(-15deg);
        }
        100% {
          transform: rotate(0deg);
        }
      }
    }
    .miss-draw {
      margin-top: 20px;
      text-align: center;
      img {
        width: 114px;
        height: 100px;
      }
    }
  }
}
</style>
